
import * as crypto from "crypto";
import { validate } from "uuid";
import { v5 } from "uuid";

import { isBrowser } from "#/utils/environment";
export { v4 as uuid } from "uuid";


export const isValidUUID = (v: string | any): v is string =>
  typeof v === "string" && validate(v);

export const uuidFromString = (s: string): string => {
  if (isBrowser()) {
    throw new Error("uuidFromString is not available in the browser");
  }
  return v5(crypto.createHash("sha1").update(s).digest(), v5.URL);
};